export default __webpack_public_path__ + "images/43261d02dad1c5d9144af818b93f24d7.svg";